import type { ServerProvider } from "@cmmd-forge/contracts";

/**
 * Whether a resolved provider inventory came from a stopped Environment's
 * last-known catalog, and if so, when that Environment published it.
 *
 * The discriminant is which list WON, not any property of the providers
 * themselves. Reference equality against the caller's own `lastKnownProviders`
 * array answers that directly: the resolved inventory IS that array only when
 * the last-known path actually won, so this cannot drift from
 * `resolveNewThreadProviderInventory`'s branches as they evolve, and it never
 * has to read a live provider's `checkedAt` and guess whether it looks old
 * enough to be a last-known one. The path decides, not the data.
 */
export function resolveLastKnownInventoryPublishedAt(input: {
  readonly inventory: ReadonlyArray<ServerProvider> | null;
  readonly lastKnownProviders?: ReadonlyArray<ServerProvider> | null;
  readonly lastKnownInventoryPublishedAt?: string | null;
}): string | null {
  const usedLastKnownInventory =
    input.inventory !== null &&
    input.lastKnownProviders != null &&
    input.inventory === input.lastKnownProviders;
  return usedLastKnownInventory ? (input.lastKnownInventoryPublishedAt ?? null) : null;
}
